import { render, staticRenderFns } from "./PageDailyGamePlay.vue?vue&type=template&id=35387f8e&"
import script from "./PageDailyGamePlay.vue?vue&type=script&lang=js&"
export * from "./PageDailyGamePlay.vue?vue&type=script&lang=js&"
import style0 from "./PageDailyGamePlay.vue?vue&type=style&index=0&id=35387f8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports